import { GET_VENDORS, ADD_VENDOR, UPDATE_VENDOR, UPDATE_VENDOR_EXP_EXPENSE } from 'redux/actionTypes';

function findVendorIndex(state, vendorId) {
    return state.findIndex(vendor => vendor.id === vendorId);
};

export default function vendors(state = [], action) {
    switch(action.type) {
        case GET_VENDORS:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_VENDOR:
            return [
                action.payload,
                ...state
            ];
        case UPDATE_VENDOR:
            const index = findVendorIndex(state, action.payload.id);
            return [
                ...state.slice(0, index),
                action.payload,
                ...state.slice(index + 1)
            ];
        case UPDATE_VENDOR_EXP_EXPENSE:
            const expenseIndex = findVendorIndex(state, action.payload.id);
            return [
                ...state.slice(0, expenseIndex),
                {
                    ...state[expenseIndex],
                    expectedExpenses: action.payload.expectedExpenses
                },
                ...state.slice(expenseIndex + 1)
            ];
        default:
            return state;
    }
};